import qs from 'query-string'

export const token = qs.parse(location.hash.split('?')[1]).token
export const rootPath = queryPath()
export const localhost = rootPath.substring(0, rootPath.lastIndexOf('/'))

export function queryString () {
  const q = window.location.search.substring(1)
  const a = q.split('&')
  const b = {}
  for (let i = 0; i < a.length; i++) {
    const c = a[i].indexOf('=')
    if (c === -1) continue
    const d = a[i].substring(0, c)
    const e = a[i].substring(c + 1)
    b[d] = e
  }
  return b
}

export function queryPath () {
  const curPath = window.document.location.href
  const pathName = window.document.location.pathname
  const pos = curPath.indexOf(pathName)
  const localhostPath = curPath.substring(0, pos)
  const projectName = pathName.substring(0, pathName.substr(1).indexOf('/') + 1)
  return (localhostPath + projectName)
}

// 返回顶部

export function backToTop (e) {

}
